module.exports = __webpack_public_path__ + "static/media/greenwashing_threat.870792da.png";